import { gsap } from 'gsap';
import { WbTrapFocus } from './WbTrapFocus';
import { throttle } from 'lodash';

export class WbMasthead {
  constructor() {
    this.lastScroll = 0;
    this.WbTrapFocus = new WbTrapFocus({
      ele: document.querySelector('#wb-menu-burger'),
      activeClass: 'wb-header--open',
    });
    this.init();
  }

  init() {
    return new Promise((resolve, reject) => {
      this.resize(true);
      this.bindListeners();

      resolve();
    });
  }

  bindListeners() {
    this.addScrollListener();
    this.addBurgerListener();
    this.addResizeListener();
  }

  addResizeListener() {
    const _this = this;
    window.addEventListener('resize', throttle(_this.resize.bind(_this), 200));
  }

  addBurgerListener() {
    const _this = this;
    document
      .querySelector('body')
      ._addCustomEventListener('click', '.wb-burger, .wb-search-overlay__trigger', _this.toggleMenu.bind(_this));
  }

  addScrollListener() {
    const _this = this;

    document.addEventListener('scroll', (e) => {
      const headerAlert = document.querySelector('#wb-alert');
      let headerAlertHeight = 0;

      if (headerAlert) headerAlertHeight = headerAlert.clientHeight;

      _this.lastScroll = _this.currentScroll;
      _this.currentScroll = window.scrollY;

      if (document.querySelector('.wb-header--open')) return false;

      // Prevent errors
      // TODO : Uncomment this line if there are issues with an Apple magic mouse
      // if (Math.abs(_this.currentScroll - _this.lastScroll) < 2) return false;

      // Scrolling down
      if (_this.currentScroll > _this.lastScroll && _this.currentScroll > 0) {
        // Fix element if we scroll past its height
        if (
          _this.currentScroll > _this.eleHeight + headerAlertHeight &&
          !_this.ele.classList.contains('wb-header--fixed')
        ) {
          _this.ele.classList.add('wb-header--fixed', 'wb-header--hidden');
          gsap.to(_this.ele, { y: -_this.eleHeight, marginTop: 0, duration: 0 });
        }
        // Hide element while scrolling down
        else if (
          !_this.ele.classList.contains('wb-header--hidden') &&
          _this.ele.classList.contains('wb-header--fixed')
        ) {
          _this.ele.classList.add('wb-header--hidden');
          document.querySelector('html').classList.remove('has-visible-header');
          gsap.to(_this.ele, { y: -_this.eleHeight, duration: 0.15 });
        }
      }
      // Scrolling up
      else {
        // Show element while scrolling up
        if (_this.ele.classList.contains('wb-header--hidden')) {
          _this.ele.classList.remove('wb-header--hidden');
          document.querySelector('html').classList.add('has-visible-header');
          gsap.to(_this.ele, { y: 0, duration: 0.15 });
        }

        // Release when we reach the top of the page
        if (_this.currentScroll <= 2 || _this.currentScroll <= headerAlertHeight) {
          _this.ele.classList.remove('wb-header--fixed');
          document.querySelector('html').classList.remove('has-visible-header');
        }
      }
    });

    document.dispatchEvent(new CustomEvent('scroll'));
    _this.setInitialScrollState();
  }

  setInitialScrollState() {
    const _this = this;
    const headerAlert = document.querySelector('#wb-alert');
    let headerAlertHeight = 0;

    if (headerAlert) headerAlertHeight = headerAlert.clientHeight;

    if (
      _this.currentScroll > _this.eleHeight + headerAlertHeight &&
      !_this.ele.classList.contains('wb-header--fixed')
    ) {
      _this.ele.classList.add('wb-header--fixed', 'wb-header--hidden');
      gsap.to(_this.ele, { marginTop: 0, duration: 0 });
    }
  }

  toggleMenu(e) {
    return new Promise((resolve, reject) => {
      const target = e.target;
      const burgers = document.querySelectorAll('.wb-burger');
      const menus = document.querySelector('#wb-menu-burger');
      const duration = document.querySelector('.wb-transitioning') ? 0 : 0.35;

      if (target.classList.contains('wb-search-overlay__trigger') || target.closest('.wb-search-overlay__trigger')) {
        setTimeout(() => {
          document.querySelector('#wb-search-input').select();
        }, 10);
      }

      if (document.querySelector('#masthead').querySelector('.is-animating')) {
        reject('Target is animating.');
        return false;
      }

      const headerIsOpen = document.querySelector('.wb-header--open');

      burgers?.forEach((burger) => {
        burger._toggleAriaExpanded();
        burger.classList.add('is-animating');
      });

      this.ele.classList.add('wb-header--open');
      menus.classList.add('wb-header--open');

      document.querySelector('body').classList.add('--locked');

      menus
        ._slideToggle(duration)
        .then(() => {
          burgers?.forEach((burger) => {
            burger.classList.remove('is-animating');
          });

          if (headerIsOpen) {
            document.querySelector('body').classList.remove('--locked');
            this.ele.classList.remove('wb-header--open');
            menus.classList.remove('wb-header--open');
          }
        })
        .then(resolve);
    });
  }

  closeMenu() {
    if (document.querySelector('.wb-header--open')) {
      document.querySelector('.wb-burger').dispatchEvent(new Event('click'));
    }
  }

  resize(force = false) {
    const _this = this;
    this.ele = document.querySelector('#masthead');

    if (this.vw != this.oldVw || force) {
      this.oldVw = this.vw;
      this.vw = window.innerWidth;
      this.vh = window.innerHeight;
      this.eleHeight = this.ele.clientHeight;

      this.closeMenu();
    }
  }
}
